import React, { useEffect, useState } from 'react';
import { Grid, Paper, Typography, MenuItem, Select, Button, Divider } from '@material-ui/core';
import AccionesBusqueda from './AccionesBusqueda';
import DetalleParticipante from './DetalleParticipante';
import ResumenEntrega from './ResumenEntrega';
import ReporteCSV from './ReporteCSV';
import { useSelector, useDispatch } from 'react-redux';

import { eventParticipants } from '../../../../data-store/actions/registry-actions';
import DashboardEntrega from './DashboardEntrega';
import SimpleDialogDemo from '../../Modals/SimpleDialog';
import ConfiguracionEntregaKits from './ConfiguracionEntregaKits';

const EntregaKitsContainer = ({ eventoIndex, perfil }) => {
    const [configEntrega, setConfigEntrega] = useState(null);
    const [itemSeleccionado, setItemSeleccionado] = useState(null);
    const [detalleParticipante, setDetalleParticipante] = useState(null);

    const registryConfiguration = useSelector(
        (state) => state.registry.registryConfiguration
    );


    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(eventParticipants(eventoIndex))

        const data = registryConfiguration.configuracion.entregaKits;
        console.log("kits", data)
        const itemsArray = Object.values(data.items || {});
        setConfigEntrega({
            ...data,
            itemsArray
        });
        console.log("kits", data)

        if (itemsArray.length === 1) {
            setItemSeleccionado(itemsArray[0]);
        }
    }, [eventoIndex]);

    const handleItemSelect = (e) => {
        const selectedCode = e.target.value;
        const item = configEntrega.itemsArray.find((i) => i.code === selectedCode);
        setItemSeleccionado(item);
        setDetalleParticipante(null); // limpiar detalle anterior
    };

    if (!configEntrega || !configEntrega.available) {
        return (
            <Paper style={{ padding: 24, backgroundColor: '#f44336', color: 'white' }}>
                <Typography variant="h6" align="center">Módulo de kits disponible solo para el día de la entrega</Typography>
            </Paper>
        );
    }

    return (
        <Grid container column justify="center">
            <Grid item xs={12} sm={3}>
            </Grid>

            <Grid item xs={12} sm={6}>
                {(perfil === "MasterOrganizador" || perfil === "master") && (

                    <SimpleDialogDemo buttonText={"Configuración del módulo para entrega de kits"}>
                        <div style={{ padding: 20 }}>
                            <ConfiguracionEntregaKits />
                        </div>
                    </SimpleDialogDemo>
                )}
            </Grid>

            <Grid item xs={12} sm={3}>
            </Grid>

            <Grid item xs={12} sm={3}>
            </Grid>
            <Grid item xs={12} sm={6}>

                <Paper style={{ padding: 24 }}>
                    <Typography variant="h4" align="center" gutterBottom>Módulo de entrega Kits</Typography>

                    {configEntrega.itemsArray.length > 1 ? (
                        <Grid container justify="center" style={{ marginBottom: 24 }}>
                            <Select
                                value={itemSeleccionado ? itemSeleccionado.code : ''}
                                onChange={handleItemSelect}
                                displayEmpty
                            >
                                <MenuItem value="" disabled>Selecciona el artículo a entregar</MenuItem>
                                {configEntrega.itemsArray.map((item) => (
                                    <MenuItem key={item.code} value={item.code}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    ) : (
                        <Typography align="center" variant="h6" gutterBottom>
                            Artículo a entregar: {itemSeleccionado?.name}
                        </Typography>
                    )}

                    {itemSeleccionado && (
                        <>
                            <AccionesBusqueda
                                onParticipanteEncontrado={(participante) => setDetalleParticipante(participante)}
                                itemSeleccionado={itemSeleccionado}
                                eventoIndex={eventoIndex}
                            />
                            <Divider style={{ margin: '24px 0' }} />

                            {detalleParticipante && (
                                <DetalleParticipante
                                    participanteId={detalleParticipante.key}
                                    itemAEntregar={itemSeleccionado}
                                    eventoIndex={eventoIndex}
                                    perfil={perfil}
                                    onEntregado={(data) => setDetalleParticipante(data)}
                                />
                            )}

                            <ResumenEntrega eventoIndex={eventoIndex} />
                        </>
                    )}
                    {/* <DashboardEntrega /> */}
                </Paper>
            </Grid>
            <Grid item xs={12} sm={3}>
            </Grid>
            <Grid item xs={12} sm={12}>

                <ReporteCSV eventoIndex={eventoIndex} config={configEntrega} />
            </Grid>

        </Grid>
    );
};

export default EntregaKitsContainer;
